module.exports = __webpack_public_path__ + "img/team-4.897617b8.jpg";